<template>
  <div>
     <v-container>
      <v-card v-if="!$store.getters.pagesFormStatus && !$store.getters.pagePublishRequest">
        <v-card-title>
          <div class="w-100 d-flex flex-row justify-content-between">
            <div>  مدیریت فعالیت های کسب و کار </div>
    
          </div>
        </v-card-title>
        
        <v-divider> </v-divider>
        <v-card-text>
          <my-activity-list> </my-activity-list>
        </v-card-text>
      </v-card>
      <!-- <pages-form v-else-if="$store.getters.pagesFormStatus && !$store.getters.pagePublishRequest"> </pages-form>
      <publish-request-pages-list v-else-if="!$store.getters.pagesFormStatus && $store.getters.pagePublishRequest"></publish-request-pages-list> -->
    </v-container>
  </div>
</template>

<script>
import MyActivityList from "../components/MyActivityList.vue";
export default {
  components: {
    MyActivityList
  },
//    methods: {
//     openCreateOrEditDialog() {
//       this.$store.commit("setPagesFormStatus", true);
//     },
//     openPublishRequestPage(){
//       this.$store.commit("setPagePublishRequest", true);
//     }
//   },
   mounted() {
    // this.$store.dispatch(SET_BREADCRUMB, [{ title: "صفحات" }]); 
  },
};
</script>

<style>

</style>